<template>
  <div class="bh-page">
    <header class="bh-page-hero">
      <div v-reveal class="bh-container">
        <h1 class="bh-page-hero__title">Become a sponsor</h1>
        <p class="bh-page-hero__lead">
          Partner with the Black Hills Mountain Lion Foundation to educate the
          next generation of hunters and support responsible conservation.
        </p>
      </div>
    </header>

    <section class="bh-section">
      <div v-reveal class="bh-container page-prose">
        <h2 class="bh-section__title">Why sponsor?</h2>
        <ul class="benefit-list">
          <li
            v-for="(benefit, index) in benefits"
            :key="benefit.title"
            v-reveal="{ delay: index * 90 }"
          >
            <strong>{{ benefit.title }}</strong> — {{ benefit.description }}
          </li>
        </ul>

        <h2 class="bh-section__title">How to sponsor</h2>
        <p>
          Support us with in-kind donations or monetary contributions. Reach out
          and we will walk you through opportunities for the upcoming banquet
          season.
        </p>
        <a
          class="bh-btn bh-btn--secondary"
          :href="'mailto:' + email + '?subject=Sponsor%20Request'"
        >
          Contact us about sponsorship
        </a>
      </div>
    </section>

    <section class="bh-section flyer-section">
      <div class="bh-container">
        <figure v-reveal="{ variant: 'scale' }" class="flyer-frame">
          <img
            :src="require('@/assets/sponsorflyer.jpg')"
            alt="Black Hills Mountain Lion Foundation sponsorship flyer"
          />
        </figure>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SponsorshipPage",
  data() {
    return {
      email: "blackhillsmountainlionhunters@gmail.com",
      benefits: [
        {
          title: "Prominent recognition",
          description:
            "your brand featured in event materials and social campaigns.",
        },
        {
          title: "VIP seating",
          description:
            "reserved seating for eight at our annual banquet with dinner and drinks included.",
        },
        {
          title: "Special acknowledgment",
          description:
            "your commitment highlighted during the event program.",
        },
        {
          title: "Networking",
          description:
            "connect with outdoor enthusiasts and community leaders.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.page-prose {
  max-width: 42rem;
}

.page-prose p {
  font-size: 1.05rem;
  line-height: 1.65;
  color: var(--bh-ink);
  margin: 0 0 1.5rem;
}

.benefit-list {
  list-style: none;
  margin: 0 0 2.5rem;
  padding: 0;
}

.benefit-list li {
  padding: 1rem 0 1rem 1rem;
  border-left: 3px solid var(--bh-amber);
  margin-bottom: 0.85rem;
  background: var(--bh-surface);
  border-radius: 0 var(--bh-radius) var(--bh-radius) 0;
  line-height: 1.55;
  color: var(--bh-ink);
}

.flyer-section {
  padding-top: 0;
}

.flyer-frame {
  margin: 0 auto;
  max-width: 720px;
  background: var(--bh-surface);
  border: 1px solid var(--bh-border);
  border-radius: var(--bh-radius);
  overflow: hidden;
  box-shadow: var(--bh-shadow);
}

.flyer-frame img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
